import React, { useEffect } from 'react'
import { ArrowLeft, Wrench } from 'lucide-react'
import { Link } from 'react-router-dom'
import haystackLogo from '../images/haystack conference logo 1 (1).png'

const Register = () => {
	useEffect(() => {
		window.scrollTo(0, 0)
		document.title = 'Registration Temporarily Paused | Haystack Conference'

		let description = document.head.querySelector('meta[name="description"]')
		if (!description) {
			description = document.createElement('meta')
			description.setAttribute('name', 'description')
			document.head.appendChild(description)
		}

		description.setAttribute(
			'content',
			'Registration for the Haystack Conference is temporarily paused while we make technical adjustments.'
		)
	}, [])

	return (
		<main className="register relative flex min-h-screen items-center justify-center overflow-hidden px-5 py-12">
			<div
				className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-white/30 blur-3xl"
				aria-hidden="true"
			/>
			<div
				className="absolute -bottom-24 -right-16 h-72 w-72 rounded-full bg-greenY/30 blur-3xl"
				aria-hidden="true"
			/>

			<section className="relative w-full max-w-2xl rounded-3xl border border-white/70 bg-white/80 px-6 py-10 text-center shadow-2xl backdrop-blur-sm sm:px-12 sm:py-14">
				<Link
					to="/"
					className="inline-block rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-greenX focus-visible:ring-offset-4"
					aria-label="Go to the Haystack Conference homepage"
				>
					<img
						src={haystackLogo}
						alt="Haystack Conference"
						className="mx-auto h-auto w-44 sm:w-52"
					/>
				</Link>

				<div className="mx-auto mb-7 mt-10 flex h-16 w-16 items-center justify-center rounded-2xl bg-greenX text-greenY shadow-lg shadow-greenX/20">
					<Wrench size={29} strokeWidth={1.8} aria-hidden="true" />
				</div>

				<p className="mb-4 font-clashSemibold text-xs uppercase tracking-[0.24em] text-greenX/70">
					Registration update
				</p>
				<h1 className="font-clashSemibold text-3xl leading-tight text-blackX sm:text-4xl md:text-5xl">
					We&rsquo;ll be back soon
				</h1>
				<p className="mx-auto mt-5 max-w-lg font-clashRegular text-base leading-7 text-blackX/70 sm:text-lg">
					We&rsquo;re making a few technical adjustments to improve your registration experience. Registration will resume soon.
				</p>

				<div className="mt-9 border-t border-greenX/10 pt-7">
					<Link
						to="/"
						className="inline-flex items-center gap-2 rounded-lg bg-greenX px-6 py-3 font-clashMedium text-sm text-white transition duration-200 hover:-translate-y-0.5 hover:bg-deepGreen focus:outline-none focus-visible:ring-2 focus-visible:ring-greenX focus-visible:ring-offset-2"
					>
						<ArrowLeft size={17} aria-hidden="true" />
						Back to homepage
					</Link>
				</div>
			</section>
		</main>
	)
}

export default Register
